export default __webpack_public_path__ + "static/media/survivorship.62ad9da3.png";